import { useCallback, useEffect, useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../../../config/firebase";

interface StripeSubscriptionStatus {
  hasStripeSubscription: boolean;
  stripeCustomerId?: string;
  currentPeriodEnd?: string; // ISO date when access ends
  activePriceId?: string;
  cancelAt?: string;
}

export function useStripeSubscriptionStatus(userId: string | null) {
  const [isLoading, setIsLoading] = useState(true);
  const [status, setStatus] = useState<StripeSubscriptionStatus | null>(null);

  const check = useCallback(async () => {
    if (!userId) {
      setIsLoading(false);
      setStatus(null);
      return;
    }
    setIsLoading(true);
    try {
      const functions = getFunctions(app, "europe-west1");
      const getStatus = httpsCallable<{}, StripeSubscriptionStatus>(
        functions,
        "getStripeSubscriptionStatus"
      );
      const result = await getStatus({});

      setStatus(result.data);
    } catch (err) {
      setStatus({ hasStripeSubscription: false });
    } finally {
      setIsLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    check();
  }, [check]);

  return {
    hasStripeSubscription: status?.hasStripeSubscription ?? false,
    currentPeriodEnd: status?.currentPeriodEnd,
    activePriceId: status?.activePriceId,
    cancelAt: status?.cancelAt,
    isLoading,
    refetch: check,
  };
}
